<template>
  <div class="sharing-option">
    <div class="share-card-background">
      <div class="share-card">
        <div :class="['card-top', light ? 'light' : 'green']">
          <img :src="light ? require('../../../../assets/logo-colored.png') : require('../../../../assets/logo-white.png')" width="70"/>
          {{label}}
        </div>
        <div class="card-inner">
          <span class="rank-value">
            {{numberValue}}
            <span v-if="!numberFrom" class="percentage">%</span>
          </span>
          <span class="rank-of" v-if="numberFrom">of {{numberFrom}} Surgeons</span>
        </div>
      </div>
    </div>

    <div class="hidden">
      <div class="share-card-background" ref="option">
        <div class="share-card">
          <div :class="['card-top', light ? 'light' : 'green']">
            <img :src="light ? require('../../../../assets/logo-colored.png') : require('../../../../assets/logo-white.png')" width="70"/>
            {{label}}
          </div>
          <div class="card-inner">
            <span class="rank-value">
              {{numberValue}}
              <span v-if="!numberFrom" class="percentage">%</span>
            </span>
            <span class="rank-of" v-if="numberFrom">of {{numberFrom}} Surgeons</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import {uploadImageForSharing} from '../../../../api/sharing.js'

export default {
  props: {
    numberValue: Number,
    numberFrom: Number,
    label: String,
    light: Boolean
  },

  data() {
    return {
      canvas: null
    }
  },

  computed: {
    baseUrl() {
      const getUrl = window.location;
      return getUrl.origin
    }
  },

  mounted() {
    html2canvas(this.$refs['option'], {scrollY: 0, scrollX: 0, scale: 2}).then((canvas) => {
      this.canvas = canvas
    });
  },

  methods: {
    close() {
      this.$emit('close');
    },

    generateUrl() {
      return new Promise((resolve, reject) => {
        this.canvas.toBlob((res) => {
          const formData = new FormData()
          formData.append('image', res)

          uploadImageForSharing(formData).then(res => {
            // const choppedLink = res.url.substring(res.url.indexOf('/share'))
            // resolve(`${origin}${choppedLink}`)
            resolve(res.url)

          }).catch(err => {
            console.log(err);
            reject()
          })
        })
      })
    },

    shareOnFacebook() {
      if(this.canvas) {
        this.generateUrl().then(link => {
          FB.ui({
            method: 'share',
            href: link
          }, function(response) {
            console.log(response);
          })
        })
      }
    },

    shareOnLinkedIn() {
      if(this.canvas) {
        this.generateUrl().then(link => {
          window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${link}`)
        })
      }
    },

    downloadImage() {
      if(this.canvas) {
        const link = document.createElement('a');
        link.download = 'score.jpeg';
        link.href = this.canvas.toDataURL('image/jpeg')
        link.click();
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../../../styles/main.sass'

.sharing-option
  border-radius: 3px
  width: 660px / 2 - 10px
  background-color: #E4E4E4
  padding: 50px 20px
  display: flex
  justify-content: center

  @media screen and (max-width: 800px)
    width: 100%

  .share-card-background
    padding: 20px 20px
    background-color: #E4E4E4
    display: flex
    justify-content: center
    align-items: center

    .share-card
      width: 212px
      height: 176px
      background-color: white
      border-radius: 5px
      overflow: hidden
      display: flex
      flex-direction: column

      .card-top
        width: 100%
        padding: 14px 0 12px
        display: flex
        align-items: center
        justify-content: center
        font-size: 14px
        color: white

        &.green
          background-color: #8BC34A

        &.light
          background-color: #EDF4F8
          color: inherit

        img
          margin-right: 5px

      .card-inner
        width: 100%
        flex-grow: 1
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center

        .rank-value
          font-size: 43px
          margin-bottom: 8px
          display: flex
          align-items: flex-end

          .percentage
            font-size: 16px
            margin: 0 -11px 6px 4px

        .rank-of
          font-size: 14px

  .hidden
    overflow: hidden
    height: 0
    width: 0

    .share-card-background
      width: 1200px
      height: 630px

      .share-card
        transform: scale(3.2)
</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/SocialSharing/Option.vue